import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMapLink = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "b",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 21.2 12.8",
	style: { enableBackground: "new 0 0 21.2 12.8" },
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "c",
		children: /* @__PURE__ */ _jsx("g", {
			id: "d",
			transform: "translate(53 175)",
			children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M-47.7-167c0,0.6,0.1,1.1,0.2,1.6h-0.8c-2.6,0-4.8-2.1-4.8-4.8s2.1-4.8,4.8-4.8h5.3c2.6,0,4.8,2.1,4.8,4.8 s-2.1,4.8-4.8,4.8h-0.3c-0.5-0.4-0.7-1-0.7-1.6h1.1c1.8,0,3.2-1.4,3.2-3.2s-1.4-3.2-3.2-3.2h-5.3c-1.8,0-3.2,1.4-3.2,3.2 s1.4,3.2,3.2,3.2C-48.2-167-47.7-167-47.7-167z M-31.8-167c0,2.6-2.1,4.8-4.8,4.8h-5.3c-2.6,0-4.8-2.1-4.8-4.8s2.2-4.8,4.8-4.8 h0.3c0.4,0.4,0.7,1,0.7,1.6h-1.1c-1.8,0-3.2,1.4-3.2,3.2s1.4,3.2,3.2,3.2h5.3c1.8,0,3.2-1.4,3.2-3.2s-1.4-3.2-3.2-3.2h-0.5 c0-0.6-0.1-1.1-0.2-1.6h0.8C-33.9-171.8-31.7-169.7-31.8-167L-31.8-167z" }) })
		})
	})]
});
const ForwardRef = forwardRef(SvgMapLink);
export default ForwardRef;
